import React from 'react';
const PricingLink = () => {
    return (<a id="pricing-link" className="text-gray-900 text-sm font-semibold font-inter no-underline leading-tight" href="/pricing">
      Pricing
    </a>);
};
export default PricingLink;
